/** Absolute or same-origin URL for GET /api/public-config (no auth). */
export function getPublicConfigUrl() {
  const apiUrl = process.env.API_URL || '/api';
  if (apiUrl.startsWith('http')) {
    const base = apiUrl.replace(/\/api\/?$/i, '');
    return `${base}/api/public-config`;
  }
  return '/api/public-config';
}
